/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { editor, MarkerSeverity, Uri } from "monaco-editor/esm/vs/editor/editor.api";

export const validateWalkthrough = (fileName: string): boolean => {
  const model = editor.getModel(Uri.parse(fileName));
  if (model) {
    editor.setModelMarkers(model, "walkthrough", []);
    const value = model.getValue();
    const lines = value.split("\n");
    const markers: editor.IMarkerData[] = [];
    let state = "root";
    lines.forEach((line, index) => {
      if (state === "root") {
        if (/^\s{0,3}#(?:[^\\#])+(?:#)?/.test(line)) {
          state = "step_header";
        } else if (!/\s*/.test(line)) {
          markers.push({
            severity: MarkerSeverity.Error,
            message: "Invalid Step.",
            startLineNumber: index + 1,
            endLineNumber: index + 1,
            startColumn: 1,
            endColumn: line.length + 1,
          });
        }
      } else if (state === "step_header") {
        if (/^\s{0,3}#(?:[^\\#])+(?:#)?/.test(line)) {
          markers.push({
            severity: MarkerSeverity.Error,
            message: "Invalid Step. # headers are reserved for title steps",
            startLineNumber: index + 1,
            endLineNumber: index + 1,
            startColumn: 1,
            endColumn: line.length + 1,
          });
        } else if (/^\s*\[_metadata_:.*\]:-\s*"\w+"/.test(line)) {
          state = "state_metadata";
        } else {
          state = "step_body";
        }
      } else if (state === "step_body") {
        if (/^\s{0,3}#(?:[^\\#])+(?:#)?/.test(line)) {
          markers.push({
            severity: MarkerSeverity.Error,
            message: "Invalid Step. Previous step is missing metadata.",
            startLineNumber: index + 1,
            endLineNumber: index + 1,
            startColumn: 1,
            endColumn: line.length + 1,
          });
        } else if (/^\s*\[_metadata_:\w+\]:-\s*"\w+"/.test(line)) {
          state = "state_metadata";
        }
      } else if (state === "state_metadata") {
        if (/\s*/.test(line)) {
          state = "root";
        }
      }

    });

    if (state !== "root" && state !== "state_metadata") {
      markers.push({
        severity: MarkerSeverity.Error,
        message: "Invalid Step. Missing metadata for step.",
        startLineNumber: lines.length,
        endLineNumber: lines.length,
        startColumn: 1,
        endColumn: lines[lines.length - 1].length + 1,
      });
    }

    editor.setModelMarkers(model, "walkthrough", markers);
    return markers.length <= 0;
  }
  return false;
};
